<template>
  <v-container fluid class="app-version-page">
    <h1 class="text-h5 font-weight-bold mb-4">
      <v-icon left color="primary">mdi-cellphone-arrow-down</v-icon>Wersja aplikacji kierowcy
    </h1>

    <v-alert type="info" outlined dense max-width="820" class="mb-4">
      Kierowcy, którzy mają w telefonie wersję <b>niższą niż „Minimalna wersja"</b>, przy starcie
      aplikacji zobaczą <b>blokujący ekran z linkiem do sklepu</b> i nie przejdą dalej, dopóki nie
      zaktualizują. Przełącznik <b>„Wymuś aktualizację"</b> blokuje wszystkich niezależnie od wersji
      (awaryjny wyłącznik). „Najnowsza wersja" jest tylko informacyjna.
    </v-alert>

    <v-row>
      <v-col
        v-for="p in platformDefs"
        :key="p.key"
        cols="12"
        md="6"
      >
        <v-card outlined>
          <v-card-title class="subtitle-1 font-weight-bold">
            <v-icon left>{{ p.icon }}</v-icon>{{ p.label }}
          </v-card-title>
          <v-card-text>
            <v-text-field
              v-model="form[p.key].latestVersion"
              label="Najnowsza wersja (w sklepie)"
              placeholder="np. 1.0.1" outlined dense
              prepend-inner-icon="mdi-tag"
            />
            <v-text-field
              v-model="form[p.key].minVersion"
              label="Minimalna wersja (poniżej = wymuszenie)"
              placeholder="np. 1.0.0" outlined dense
              hint="Kierowcy z niższą wersją muszą zaktualizować. Nie może być wyższa niż najnowsza w sklepie." persistent-hint
              prepend-inner-icon="mdi-shield-alert"
              class="mb-2"
            />
            <v-text-field
              v-model="form[p.key].storeUrl"
              label="Link do sklepu"
              placeholder="https://..." outlined dense
              prepend-inner-icon="mdi-link-variant"
            />
            <v-textarea
              v-model="form[p.key].updateMessage"
              label="Komunikat dla kierowcy (opcjonalnie)"
              placeholder="np. Dostępna jest ważna aktualizacja."
              rows="2" auto-grow outlined dense
              prepend-inner-icon="mdi-message-text"
            />
            <v-switch
              v-model="form[p.key].forceUpdate"
              inset color="error"
              :label="form[p.key].forceUpdate ? 'Wymuszenie WŁĄCZONE (kierowcy poniżej najnowszej wersji)' : 'Wymuś aktualizację do najnowszej wersji'"
              hint="Blokuje tylko tych, którzy mają starszą wersję niż podana wyżej najnowsza. Kierowca z najnowszą wersją nie zobaczy ekranu aktualizacji."
              persistent-hint
              class="mt-0"
            />

            <div v-if="form[p.key].updatedAt" class="caption grey--text mb-3">
              Ostatnia zmiana: {{ formatDate(form[p.key].updatedAt) }}
            </div>

            <v-btn color="primary" :loading="form[p.key].saving" @click="save(p.key)">
              <v-icon left>mdi-content-save</v-icon>Zapisz ({{ p.short }})
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Swal from 'sweetalert2';
const axios = require('axios');

export default {
  name: 'AppVersionPage',
  data() {
    return {
      platformDefs: [
        { key: 'ios', label: 'iOS — App Store', short: 'iOS', icon: 'mdi-apple' },
        { key: 'android', label: 'Android — Google Play', short: 'Android', icon: 'mdi-android' },
      ],
      form: {
        ios: { latestVersion: '', minVersion: '', storeUrl: '', updateMessage: '', forceUpdate: false, updatedAt: null, saving: false },
        android: { latestVersion: '', minVersion: '', storeUrl: '', updateMessage: '', forceUpdate: false, updatedAt: null, saving: false },
      },
    };
  },
  created() {
    const isHead =
      localStorage.getItem('actualRole') === 'headadmin' ||
      localStorage.getItem('isHead') === 'true';
    if (!isHead) {
      this.$router.replace('/').catch(() => {});
      return;
    }
    this.load();
  },
  methods: {
    authHeaders() {
      return { Authorization: 'Bearer ' + localStorage.getItem('token') };
    },
    apiUrl(p) {
      return process.env.VUE_APP_ROOT_API + p;
    },
    formatDate(d) {
      try { return new Date(d).toLocaleString('pl-PL'); } catch (e) { return d; }
    },
    async load() {
      try {
        const res = await axios({ method: 'get', url: this.apiUrl('app-version/admin'), headers: this.authHeaders() });
        const rows = (res.data && res.data.data) || [];
        rows.forEach((r) => {
          if (!this.form[r.platform]) return;
          this.form[r.platform] = {
            latestVersion: r.latestVersion || '',
            minVersion: r.minVersion || '',
            storeUrl: r.storeUrl || '',
            updateMessage: r.updateMessage || '',
            forceUpdate: !!r.forceUpdate,
            updatedAt: r.updatedAt || null,
            saving: false,
          };
        });
      } catch (e) {
        Swal.fire('Błąd', e.response?.data?.message?.toString() || 'Nie udało się wczytać konfiguracji', 'error');
      }
    },
    async save(platform) {
      const f = this.form[platform];
      f.saving = true;
      try {
        await axios({
          method: 'put',
          url: this.apiUrl('app-version/admin'),
          headers: this.authHeaders(),
          data: {
            platform,
            latestVersion: f.latestVersion,
            minVersion: f.minVersion,
            storeUrl: f.storeUrl || undefined,
            updateMessage: f.updateMessage || undefined,
            forceUpdate: !!f.forceUpdate,
          },
        });
        Swal.fire({ title: 'Zapisano', icon: 'success', timer: 1300, showConfirmButton: false });
        await this.load();
      } catch (e) {
        Swal.fire('Błąd', e.response?.data?.message?.toString() || 'Nie udało się zapisać', 'error');
      } finally {
        f.saving = false;
      }
    },
  },
};
</script>
